import React, { createContext, useState, useContext, useCallback, useEffect } from "react";
import axios from "axios";

const AppConfigContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AppConfigProvider = ({ children }) => {
  const [appConfig, setAppConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(true);

  const fetchConfig = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/setup/config`);
      setAppConfig(response.data);
    } catch (error) {
      console.log("App config not available, using defaults");
      setAppConfig({
        app_name: "Planning Ménage Pro",
        logo_url: null,
        company_name: null,
        primary_color: "#DC2626",
        branding_setup_completed: true, // fallback: don't block on error
      });
    } finally {
      setConfigLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const companyName = appConfig?.company_name || appConfig?.app_name || "Ma Conciergerie";

  return (
    <AppConfigContext.Provider value={{ appConfig, companyName, configLoading, refreshConfig: fetchConfig }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => {
  const context = useContext(AppConfigContext);
  if (!context) {
    // Provide safe fallback if used outside provider
    return { appConfig: null, companyName: "Ma Conciergerie", configLoading: false, refreshConfig: () => {} };
  }
  return context;
};
